import { Controller } from "@hotwired/stimulus"
import { put }        from '@rails/request.js'

// Connects to data-controller="assinar"
export default class extends Controller {
  static values = {
    url: String
  }

  connect() { }

  async check(ev) {
    const assunto_id = ev.target.value
    const assinar = ev.target.checked

    const response = await put(this.urlValue, {
      body: { assunto_id: assunto_id, assinar: assinar },
      responseKind: 'turbo-stream'
    })
  }

  async checkAll(ev) {
    ev.preventDefault()
    const grupo_id = ev.params.grupoId
    const assinar = ev.params.assinar

    const response = await put(this.urlValue, {
      body: { grupo_id: grupo_id, assinar: assinar },
      responseKind: 'turbo-stream'
    })
  }

}
